module.exports = __webpack_public_path__ + "static/media/SilverMedalIcon.b8bcb840.svg";